import Footer from '../../sections/footer/Footer'
import BackToTopButton from '../../components/backToTopButton/BackToTopButton'
import HeaderSolid from '../../sections/header/HeaderSolid'

import './style.scss'
import CtaButton from '../../components/ctaButton/CtaButton'
import { useEffect, useState } from 'react'
import { PAGE_URLS } from '../../constants/hrefLinks'
import { useAppSelector } from '../../redux/hooks'
import { userStateData } from '../../data/userStateData'
import { loginConnector } from '../../server/connector/loginConnector'

function PasswordReset() {
	const [resettingPassword, setResettingPassword] = useState<boolean>(false)
	const [resetFailed, setResetFailed] = useState<boolean>(false)

	const [email, setEmail] = useState<string>('')
	const [password, setPassword] = useState<string>('')
	const [confirmPassword, setConfirmPassword] = useState<string>('')

	const [passwordContainsSpecialChars, setPasswordContainsSpecialChars] = useState<boolean>(false)
	const [passwordContainsDigit, setPasswordContainsDigit] = useState<boolean>(false)
	const [passwordLongEnough, setPasswordLongEnough] = useState<boolean>(false)

	const loginChecked: boolean = useAppSelector(state => state.user.loginChecked)

	const specialChars = `\`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~`
	const numberChars = '0123456789'

	useEffect(() => {
		// check if log in has been checked and confirmed in App.tsx
		if (loginChecked == true) {
			// confirm a user is logged in
			if (userStateData.loggedIn == true) {
				// TEMP: redirect to dashboard if user has already logged in
				window.location.replace(PAGE_URLS.DASHBOARD_CUSTOMER)
			} 
		}
	}, [loginChecked])

	const resetPasswordClicked = () => {
		setResettingPassword(true)
		const querySting: string = window.location.search;
		const urlParams: URLSearchParams = new URLSearchParams(querySting)
		const resetId: string | null = urlParams.get('resetId')

		if (resetId) {
			loginConnector.performPasswordResetRequest(email, password, resetId).then((successRequest) => {
				if (!successRequest) {
					setResetFailed(true)
					setResettingPassword(false)
				} else {
					// window.location.replace(PAGE_URLS.THANK_YOU)
					// TEMP: redirect to log in for new customer who doesn't need to wait for email
					window.location.replace(PAGE_URLS.LOG_IN)
				}
			})
		} else {
			setResetFailed(true)
			setResettingPassword(false)
		}
	}

	const passwordChangeHandler = (newValue: string) => {
		let containsSpecialChar: boolean = false
		specialChars.split('').forEach((char: string) => {
			if (newValue.includes(char)) {
				containsSpecialChar = true
			}
		})
		setPasswordContainsSpecialChars(containsSpecialChar)
		let containsNumber: boolean = false
		numberChars.split('').forEach((char: string) => {
			if (newValue.includes(char)) {
				containsNumber = true
			}
		})
		setPasswordContainsDigit(containsNumber)
		setPasswordLongEnough(newValue.length > 7)
		setPassword(newValue)
	}
	
	return (
		<>
			<div className='section-wrap section-seperator'>
				<HeaderSolid />
			</div>
			<div className='section-wrap section-seperator'>
				<div className='section-content'>
					<div className='sign-up-content'>
						<div className='sign-up-content-section'>
							<div className='sign-up-form'>
								<div className='sign-up-form-title'>Set New Password</div>
								<input 
									className='sign-up-form-input' 
									type={'email'} 
									placeholder={'Email Address *'} 
									value={email}
									onChange={(event) => {
										setEmail(event.target.value)
									}}
									disabled={resettingPassword}
								/>
								<input 
									// className='sign-up-form-input' 
									className={`${(passwordContainsSpecialChars === false || passwordContainsDigit === false || passwordLongEnough === false) && password.length > 0 ? 'sign-up-form-input sign-up-form-input-red' : 'sign-up-form-input'}`}
									placeholder={'Password *'} 
									value={password}
									onChange={(event) => {
										passwordChangeHandler(event.target.value)
									}}
									type='password'
									disabled={resettingPassword}
								/>
								{passwordContainsSpecialChars === false && <div className='sign-up-form-requirement-txt'>Must contain special character</div>}
								{passwordContainsDigit === false && <div className='sign-up-form-requirement-txt'>Must contain a digit</div>}
								{passwordLongEnough === false && <div className='sign-up-form-requirement-txt'>Must be at least 8 characters long</div>}
								<input 
									className='sign-up-form-input' 
									placeholder={'Confirm Password *'} 
									value={confirmPassword}
									onChange={(event) => {
										setConfirmPassword(event.target.value)
									}}
									type='password'
									disabled={resettingPassword}
								/>
								<CtaButton
									label='Reset Password'
									size='medium'
									onClick={() => resetPasswordClicked()}
									fullWidth={true}
									disabled={
										email === '' ||
										password === '' ||
										confirmPassword === '' ||
										password !== confirmPassword ||
										passwordContainsSpecialChars === false ||
										passwordContainsDigit === false ||
										passwordLongEnough === false
									}
								/>
								{resetFailed && <div className='sign-up-form-requirement-txt'>Failed to reset password, please contact support</div>}
							</div>
						</div>
						<div className='sign-up-content-section'>
							<img
								className='sign-up-picture'
								alt='Ski Lift'
								src='/imgs/pictures/ski-lift.png'
							/>
						</div>
					</div>
				</div>
			</div>
			<div className='section-wrap section-seperator'>
				<div className='section-content'>
					<Footer />
				</div>
			</div>
			<BackToTopButton />
		</>
	)
}

export default PasswordReset
